import { query } from '@confluence/query-preloader-tools';
import { fg } from '@confluence/feature-gating';

import { OnboardingKeysCombined } from '../../constants/onboarding-keys-combined';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const PRELOADED_KEYS = [
	'quickstart-state:isPanelOpen',
	'quickstart-state:isDismissed',
	'quickstart-state:openTaskId',
	'quickstart-state:openComponentId',
	'quickstart-state:jswConfIntroCompleted',
	'quickstart-state:hasSeenDismissedFlag',
	'quickstart-state:isMigratedUserV2',
	'quickstart-state:jswXflowSwitcherTourCompleted',
	'onboarding-origin-state:attributes',
	'quickstart-state:jswXFlowModalCompleted',
	'quickstart-state:qsv2ReadConfluenceGuideCompleted',
	'quickstart-state:qsv2InviteTeammateCompleted',
	'quickstart-state:qsv2IntegrationCompleted',
	'quickstart-state:qsv2SiteVideoTourCompleted',
	'quickstart-state:qsv2SpotlightCompleted',
	'quickstart-state:migrationsWelcomeCompleted',
	'quickstart-state:migrationsNewPageCompleted',
	'quickstart-state:migrationsCollaborateCompleted',
	'quickstart-state:migrationsFindAndOrganizePagesCompleted',
	'quickstart-state:migrationsEditAndCustomizeContentCompleted',
	'quickstart-state:nqsv2HelpCompleted',
	'quickstart-state:nqsv2CreateCompleted',
	'quickstart-state:nqsv2CollaborateCompleted',
	'quickstart-state:nqsv2Confluence101Completed',
	'onboarding-state:isFoundingAdmin',
	'onboarding-live-doc-changeboarding:hasDismissedIntroSpotlight',
	'onboarding-live-doc-changeboarding:hasDismissedLiveDocTour',
	'onboarding-live-doc-changeboarding:hasDismissedLiveDocModal',
	'onboarding-live-doc-changeboarding:hasDismissedContentWrapperTour',
	'onboarding-live-doc-changeboarding:hasDismissedAiButtonTour',
	'onboarding-live-doc-changeboarding:hasDismissedConvertToPageSpotlight',
	'onboarding-state:isRedactionsTourVisible',
	'onboarding-state:isContentWrapperLabelsTourDismissed',
	'onboarding-state:isMoreActionsTourVisible',
	'onboarding-state:isMoreActionsHintVisible',
	'random:ShareAndRestrictDialog:spotlightSeen',
	'home-onboarding-takeover-v2:hasSeenHomeNudge',
	'home-onboarding-takeover-v2:takeoverSeenAt',
	'home-onboarding-takeover-v2:onboardingActionStates',
	'home-onboarding-takeover-v2:isCollapsed',
	'home-onboarding-takeover-v2:hasSeenConfetti',
	'home-onboarding-takeover-v2:hasDismissedTakeover',
	'editor-state:editorOnboardingEligiblity',
	'editor-state:editorVisited',
	'editor-state:wasDraftBannerSeen',
	'editor-state:isDraftBannerVisible',
	'editor-state:isLandInEditorBannerVisible',
	'editor-state:hasUserPublished',
	'editor-state:successFlagCompleted',
	'editor-state:recentSpotlightOpen',
	'editor-state:recentSpotlightCompleted',
	'editor-state:editorTutorialSuccessFlagCompleted',
	'editor-state:wasEditorConversionModalSeen',
	'onboarding-intent-experiences:onboardingIntentExperienceClosed',
	'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
	'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
	'onboarding-intent-experiences:onboardingIntentExperienceLandClosed',
	'page:pagePresenceAvatarGroupSpotlightSeen',
	'page:pageTelepointerAvatarGroupSpotlightSeen',
	'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
	'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt',
	'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
	'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner',
	'onboarding-insights:hasContextualFloatingButtonBeenSeen',
	'trial-components:trialGracePeriodBannerDismissed',
	'trial-components:dismissedTrialnullDayFlag',
	'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
	'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen',
	'land-in-sample-space:hasDismissedBanner',
	'land-in-sample-space:hasSeenSampleContentFlag',
	'live-page-nudge:wasLivePageNudgeSeen',
	'nav4:isNav4GlobalSpotlightDismissed',
	'nav4:isNav4SpaceTourDismissed',
	'personalized-templates-v2:onboardingActionStates',
	'personalized-templates-v2:hasDismissedOnboardingActions',
	'personalized-templates-v2:takeoverSeenAt',
	'personalized-templates-v2:isTemplateListDismissed',
	'personalized-templates-v2:templateUsageValues',
	'templates-collection:isTaggedForTemplatesCollectionExperiment',
	'templates-collection:isTemplatesSectionDismissed',
	'onboarding-state:introWorkflow',
	'onboarding-state:legacy',
	'onboarding-state:isSampleContentV2SpotlightVisible',
	'onboarding-state:landOnPath',
	'onboarding-state:teamSpaceCreated',
	'onboarding-state:improvedGetStartedPath',
	'onboarding-state:improvedGetStartedWhiteboardPath',
	'enhance-orientation-tour:tourSeenAt',
	'enhance-orientation-tour:hasDismissedTour',
	'enhance-orientation-tour:hasCompletedTour',
	'enhance-orientation-tour:hasSeenFinishNudge',
	'nav4:isNav4CollapseReminderSpotlightDismissed',
	'storage-enforcement-state:flagsDismissedFreeThreshold',
];

export const preloadViewPageOnboardingState = () => {
	return query({
		query: getOnboardingStateGQL,
		variables: {
			key: fg('confluence_preload_all_onboarding_keys') ? OnboardingKeysCombined : PRELOADED_KEYS,
		},
	});
};
